import { useState } from 'react'
import { Check, ChevronLeft, ChevronRight, X } from 'lucide-react'
import { formatDateTime, formatDay } from '../patientFormat'
import { DOSE_STATUS, dayHeading, shiftDate } from './medicationFormat'

function MedicationTimeline({ date, onDateChange, doses, canEdit, onAdminister, onRefuse }) {
  const [reasonFor, setReasonFor] = useState(null)
  const [reason, setReason] = useState('')

  return (
    <section className="med-daily">
      <div className="med-daily-head">
        <h3>Visão diária: checklist de administração</h3>
        <div className="med-day-nav">
          <button type="button" aria-label="Dia anterior" onClick={() => onDateChange(shiftDate(date, -1))}>
            <ChevronLeft size={16} />
          </button>
          <strong>{dayHeading(date)}</strong>
          <button type="button" aria-label="Próximo dia" onClick={() => onDateChange(shiftDate(date, 1))}>
            <ChevronRight size={16} />
          </button>
        </div>
      </div>
      {!doses.length && <p className="patients-muted med-daily-empty">Nenhuma dose programada neste dia.</p>}
      <div className={`med-rail${doses.length ? '' : ' is-empty'}`}>
        {doses.map((dose) => {
          const status = dose.effective_status || dose.status
          const open = reasonFor === dose.id
          const actionable = canEdit && (status === 'pendente' || status === 'atrasado')
          const when = dose.administered_at
            ? formatDateTime(dose.administered_at)
            : `${formatDay(dose.scheduled_date)} ${dose.scheduled_time || ''}`.trim()
          return (
            <article key={dose.id} className="med-rail-item">
              <time>{dose.scheduled_time || '—'}</time>
              <span className={`med-rail-dot is-${status}`} />
              <div className={`med-rail-card is-${status}`}>
                <strong>{DOSE_STATUS[status] || status}</strong>
                <p className="med-rail-drug">{dose.name}</p>
                <p>{dose.dosage_label || 'Dose'} · {dose.route || 'Via não informada'}</p>
                <p>{dose.administered_by_name || 'Aguardando administração'}</p>
                <p>{when}</p>
                {dose.reason && <p>{dose.reason}</p>}
                {actionable && (
                  <div className="med-dose-actions">
                    <button type="button" className="patients-btn patients-btn--green patients-btn--compact" onClick={() => onAdminister(dose)}>
                      <Check size={14} /> Administrar
                    </button>
                    <button type="button" className="patients-btn patients-btn--ghost patients-btn--compact" onClick={() => { setReasonFor(open ? null : dose.id); setReason('') }}>
                      <X size={14} /> Recusar
                    </button>
                  </div>
                )}
                {open && (
                  <form
                    className="med-stock-form"
                    onSubmit={(event) => {
                      event.preventDefault()
                      if (!reason.trim()) return
                      onRefuse(dose, reason.trim())
                      setReasonFor(null)
                      setReason('')
                    }}
                  >
                    <input value={reason} onChange={(event) => setReason(event.target.value)} placeholder="Motivo da recusa" />
                    <button type="submit" className="patients-btn patients-btn--ghost patients-btn--compact">Confirmar</button>
                  </form>
                )}
              </div>
            </article>
          )
        })}
      </div>
    </section>
  )
}

export default MedicationTimeline
